import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { trim } from 'lodash';
import DateTimeDisplay from '../../../../components/date-time-display';
import JobControls from './JobControls';
import JobForm from './JobForm';
import styles from './styles.css';

class Job extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
    };
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRequestDelete = this.handleRequestDelete.bind(this);
  }

  toggleEditMode() {
    this.changeEditMode(!this.state.editMode);
  }

  changeEditMode(editMode) {
    this.setState({ editMode }, () => {
      this.props.onEditModeChange(this.state.editMode);
    });
  }

  handleSubmit(job, currentJob) {
    const p = this.props.requestEdit(job, currentJob)
    p.then(
      () => {
        this.changeEditMode(false);
      },
      () => {
        this.changeEditMode(false);
      },
    );
    return p;
  }

  handleRequestDelete(job) {
    const p = this.props.requestDelete(job);
    return p;
  }

  renderHTML(raw) {
    return (
      <span>
        {raw.split('\n').map((item, key) => {
          return (<Fragment key={key}>{item} <br /></Fragment>);
        })}
      </span>
    );
  }

  render() {
    const { job, auth } = this.props;
    if (!job) {
      return null;
    }
    const { editMode } = this.state;
    const user = job.user__id === auth._id ? 'you' : job.user.display_name;
    const text = trim(job.job).length > 0 ? this.renderHTML(job.job) : (<span className="text-muted">[job deleted]</span>);
    return (
      <div className={styles.job}>
        {!editMode &&
          <div className="clearfix">
            <div className={`pull-right ${styles.jobControls}`}>
              <JobControls
                key={job._id}
                job={job}
                requestEdit={this.toggleEditMode}
                requestDelete={this.handleRequestDelete}
              />
            </div>
            <div>
              <div>{text}</div>
              <div className="text-muted">
                <em>
                  {user !== undefined && user !== null && <span>by {user} -{' '}</span>}
                  <DateTimeDisplay
                    value={job.created_at}
                    format="shortWithTime"
                  />
                </em>
              </div>
            </div>
          </div>
        }
        {editMode &&
          <div>
            <JobForm
              job={job}
              requestSubmit={this.handleSubmit}
              showCancel
              requestCancel={this.toggleEditMode}
            />
          </div>
        }
      </div>
    );
  }
}

Job.propTypes = {
  job: PropTypes.shape({
    job: PropTypes.string,
    _id: PropTypes.string,
  }),
  auth: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
  requestEdit: PropTypes.func,
  requestDelete: PropTypes.func,
  onEditModeChange: PropTypes.func,
};

Job.defaultProps = {
  job: {
    job: '',
  },
  requestEdit: () => {},
  requestDelete: () => {},
  onEditModeChange: () => {},
};


export default Job;
